/* Add address to large columns Apr 13, 2024 */
/* Add substr for task priority Feb 22, 2025 */
/* Remove calculated(psqft now from DB),remoe largeColumns,amend cellWidth, add columnStyles Apr 30, 2026 */
/* Fix PDF export logo crash / harden column+priority+output Sep 30, 2026 */
/* Tighten PDF column widths with text wrap Oct 1, 2026 */
/* Match break pie and bar chart size and font to reportCharts wheels Oct 28, 2026 */
/* Color projectNo and projectName by project status Oct 29, 2026 */
import {fn_getTableData,fn_saveReminderOptions,fn_AsyncGET} from "@/utils/api.js";
import {fn_lkpRefIdName,fn_tenantLogo,kbdpAlert} from "@/utils/util.js";
import {refData,fn_appEnt,userSettings,tenantSettings,userInfo} from "@/utils/ref-data.js";
import {api_baseURL} from "@/utils/init.js";
import XLSX from 'xlsx/xlsx';
import JsPDF from "jspdf";
import 'jspdf-autotable';	
import {fn_drawReportChart} from "@/utils/reportCharts.js";

/** Map opportunity lookup fields → global refData keys */
const REPORT_REF_KEYS = {
	opportunityTypeId: "opportunityTypes",
	opportunityStatusId: "opportunityStatuses",
	opportunitySubStatusId: "opportunitySubStatuses",
	contractTypeId: "contractTypes",
	categoryId: "categories",
	marketSegmentId: "marketSegments",
	leadSourceId: "leadSources",
	projectStatusId: "projectStatuses",
	accountTypeId: "accountTypes",
	ownerTypeId: "ownerTypes",
	taskTypeId: "taskTypes",
	taskStatusId: "taskStatuses",
};

/**
 * Format a report cell: column valFmtFn, then row *Name field, then live refData.
 * Prevents raw Stage/Status/Contract Type IDs in PDF/Excel when lookups are stale.
 */
function fn_formatReportValue(col, val, row) {
	if (col && ['oppr','proj','acct','extr','cmpt','team'].includes(col.datatype) && val && val.name) {
		return val.name;
	}
	if (col && col.valFmtFn) {
		var formatted = col.valFmtFn(val);
		if (formatted !== val && formatted != null && formatted !== "") return formatted;
	}
	if (row && col && col.field) {
		var nameField = col.field.replace(/Id$/, "Name");
		if (nameField !== col.field && row[nameField] != null && row[nameField] !== "") {
			return row[nameField];
		}
	}
	var refKey = col && REPORT_REF_KEYS[col.field];
	if (refKey && (refData[refKey] || []).length) {
		return fn_lkpRefIdName(refData[refKey], col, val);
	}
	if (col && col.valFmtFn) return col.valFmtFn(val);
	return val;
}



function fn_generateReport(p_report) {

let {reportType,reportTitle,reportData,reportColumns,allColumns,reportSort,reportBreak,reportTotals,chartType,
    reportCharts,tableName,reportCreatedUTC,reportCreatedBy}=p_report;

console.log('p_report');
console.log(p_report);
if(reportBreak) reportColumns.splice(reportColumns.indexOf(reportBreak),1);


var pdfDoc=null;
const date = new Date();
var fileExt = reportType === 'pdf' ? 'pdf' : 'xlsx';
var filename=reportTitle +
	date.getFullYear() +
	("0" + (date.getMonth() + 1)).slice(-2) +
	("0" + date.getDate()).slice(-2) +
	("0" + date.getHours()).slice(-2) +
	("0" + date.getMinutes()).slice(-2) + "." + fileExt;
		
var columns=reportColumns;


		


switch(reportType){
    case 'excel':
		{
		
		var temp=[];
			temp = reportData.map(a => {
			let newObject = {};
			//Object.keys(a).forEach(propertyKey => {
			reportColumns.forEach(rC=>{
			newObject[rC] = a[rC];
			var column = allColumns.find(c => c.field == rC)
			if(column) newObject[rC] = fn_formatReportValue(column, a[rC], a);
               });
		return newObject;
		});
	
		reportData=[...temp];


	
			let createXLSLFormatObj = [];
			let newXlsHeader = [];
			if (allColumns.length === 0||reportData.length === 0) return;
	
			allColumns.map(column => {
					newXlsHeader.push(column.title);
					});
							
			createXLSLFormatObj.push(newXlsHeader);
						
			reportData.map(value => {
				let innerRowData = [];
				allColumns.map(val => {
				let fieldValue = value[val.field];
	
				if (val.field.split('.').length > 1) {
					fieldValue = fn_getNestedValue(value, val.field);
					}
				if (val.dataFormat && typeof val.dataFormat === 'function') 
					innerRowData.push(val.dataFormat(fieldValue))
				else 	innerRowData.push(fieldValue);  			 
			}); 
	
		
			console.log(innerRowData);
		
			createXLSLFormatObj.push(innerRowData);
		});

			let ws_name = filename.substr(1,30);
	
			let wb = XLSX.utils.book_new(),
			ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
			XLSX.utils.book_append_sheet(wb, ws, ws_name);
			XLSX.writeFile(wb, filename);
			const wopts = {bookType: 'xlsx',bookSST: false,type: 'binary'};
			let buffer = XLSX.write(wb, wopts);
			//var url = URL.createObjectURL(buffer);
			//var w = window.open(URL.createObjectURL(new Blob(buffer, {type: "application/vnd.ms-excel"})));
		}
	break;			
	case 'pdf':
	{
		
		var columnWidth={};
		var columnStyles={};
		var reportWidth=0;
		//var largeColumns=['opportunityName','clientAccountId', 'streetAddress','projectName','description','address','notes' ];
		var allReportData=[];
		var pdfRecord=[];
		var pdfData=[];
		var pdfColumns=[];
		var pdfTableColumns=[];
		var totals=[];
		var heading;
		var tableCount;
        var pdfDoc=null;
		var f_pdfDoc;
		var l;
		
		//if(reportColumns) pdfColumns=allColumns.filter(c=>reportColumns.includes(c.field));
		if(reportColumns) pdfColumns=reportColumns.map(c=>{return allColumns.filter(ac=>ac.field==c)[0];}).filter(Boolean);
		else pdfColumns=[];
		
		
		/*		
		pdfColumns.forEach(c=>{	if(largeColumns.includes(c.field)) l=500; else l=200;
								columnWidth[c.field]={cellWidth: l};
							});
		*/
 
		pdfColumns.forEach(c=>{columnWidth[c.field]={cellWidth: fn_pdfCellWidth(c)}});
														

		pdfTableColumns=pdfColumns.map(x => {return {dataKey:x.field};});			
		pdfColumns.forEach((c,i) => {
									reportWidth=reportWidth+parseInt(columnWidth[c.field].cellWidth);
									var lWidth={cellWidth:columnWidth[c.field].cellWidth,overflow: 'linebreak', valign: 'top'};
									columnStyles[c.field]=lWidth;
								});
					
		var columnHeaders=pdfColumns.map(c => c.title);
		
				allReportData = reportData.map(a => {
				let newObject = {};
					Object.keys(a).forEach(propertyKey => {
							newObject[propertyKey] = a[propertyKey];
					
							//if(newObject[propertyKey]?.length>30) 
								//newObject[propertyKey]=newObject[propertyKey].substring(0,29)+"..."; 
					});
				return newObject;
				});
				
		var format=reportWidth>750?"a3":"a4";	
		//var format="a3";
		var l_pdfDoc =fn_createPdf(pdfDoc,reportTitle, format,Math.max(reportWidth,750));
		// Heading rule is at y≈48. Charts sit under that, then the summary, then the tables.
		var contentStartY = 62;

        // Extra Carts/KPIs
		var chartsToDraw = reportCharts;
		if(chartsToDraw && (Array.isArray(chartsToDraw) ? chartsToDraw.length : chartsToDraw)){
			contentStartY = fn_drawReportChart(l_pdfDoc, chartsToDraw, reportData, contentStartY);
		}
		
		// Table Chart on Break Column chartType null, blank, or -1 means no break chart
		if(fn_isReportChartType(chartType) && reportBreak) contentStartY = fn_pdfAppendChart(l_pdfDoc, reportData, reportBreak, allColumns, chartType, contentStartY);
		
		// Report Intro
		contentStartY = fn_pdfDrawReportIntro(l_pdfDoc, reportTitle, reportCreatedUTC, reportCreatedBy, contentStartY);
		var chartStartY = contentStartY;
		
		/*
		var hasOppColorCol = (pdfColumns || []).some(function(c){
			return c && (c.field === 'opportunityNo' || c.field === 'opportunityName');
		});
		*/
		var hasOppColorCol = tableName == "Opportunities";
		if(hasOppColorCol){
			chartStartY = fn_pdfDrawWinProbColorKey(l_pdfDoc, chartStartY);
		}
		
		/*
		var hasProjColorCol = (pdfColumns || []).some(function(c){
			return c && (c.field === 'projectNo' || c.field === 'projectName');
		});
		*/
		
		var hasProjColorCol = tableName == "Projects";
		if(hasProjColorCol){
			chartStartY = fn_pdfDrawProjectStatusColorKey(l_pdfDoc, chartStartY);
		}
		
		if(reportBreak){
		
		var breakTitle=allColumns.filter(c=>c.field==reportBreak)[0].title;

        //remove Break Column from detail row.
		pdfTableColumns=pdfTableColumns.filter(c=>c.dataKey!=reportBreak);
		var valFmtFn = function(v, row) {
			var col = allColumns.filter(c=>c.field==reportBreak)[0];
			return fn_formatReportValue(col, v, row);
		};

		
		//Get all the unique break values in reportData
		var breakValues=[];
		reportData.forEach(rec =>{
			if(!breakValues.includes(rec[reportBreak])) breakValues.push(rec[reportBreak]);
			});
				
		//get the data for each break value
			breakValues.forEach(b=>{
				
				var breakValue;
				var breakSampleRow = reportData.filter(r=>r[reportBreak]==b)[0];
				if(!b) breakValue='None'; else breakValue=valFmtFn(b, breakSampleRow);
				heading=allColumns.filter(c=>c.field==reportBreak)[0].title+":"+breakValue;
				
				
				totals.length=0;
				pdfRecord.length=0;
				pdfData.length=0;
				
				var tableRows=allReportData.filter(r=>r[reportBreak]==b);
		
				tableRows.forEach(rec =>{
					pdfColumns.forEach((col,idx) => {
					var val=rec[col.field];
					var dVal=fn_formatReportValue(col, val, rec);
					if(col.field=='priority' && typeof dVal === 'string') dVal=dVal.substr(2);
					pdfRecord.push(dVal?dVal:null);
					if((reportTotals||[]).includes(col.field)) totals[idx]=totals[idx]?totals[idx]+(val?val:0):(val?val:0); else totals[idx]="";
					});
					pdfData.push(pdfRecord);
					pdfRecord=[];
				});
				
				if(pdfData.length>0) {
					tableCount=tableCount+1;
					totals[0]="Totals:"+pdfData.length;

					var formatTotals=totals.map((t,idx)=> {return (pdfColumns[idx].valFmtFn&&pdfColumns[idx].valFmtFn!=='calculated')?fn_formatReportValue(pdfColumns[idx], t):t;});
					var rowWinProbs = tableRows.map(function(r){ return r.winProbability; });
					var rowProjectStatuses = tableRows.map(function(r){ return fn_rowProjectStatus(r); });
					var headingColor=fn_breakSliceColor(l_pdfDoc, b);
					f_pdfDoc=fn_pdfAppendTable(l_pdfDoc,heading,columnHeaders,pdfTableColumns,columnStyles,pdfData,formatTotals,chartStartY,pdfColumns,rowWinProbs,headingColor,rowProjectStatuses);	
					}
			
			});
				
		}else{
				var rowWinProbsAll=[];
				var rowProjectStatusesAll=[];
				reportData.forEach(rec =>{

						pdfColumns.forEach((col,idx) => {
						var val=rec[col.field];
						var dVal=fn_formatReportValue(col, val, rec);
						if(col.field=='priority' && typeof dVal === 'string') dVal=dVal.substr(2);
						pdfRecord.push(dVal?dVal:null);
						if((reportTotals||[]).includes(col.field)) totals[idx]=totals[idx]?totals[idx]+(val?val:0):(val?val:0); else totals[idx]="";
						});
						pdfData.push(pdfRecord);
						pdfRecord=[];
						rowWinProbsAll.push(rec.winProbability);
						rowProjectStatusesAll.push(fn_rowProjectStatus(rec));
				});
				var formatTotals=totals.map((t,idx)=> {return (pdfColumns[idx].valFmtFn&&pdfColumns[idx].valFmtFn!=='calculated')?fn_formatReportValue(pdfColumns[idx], t):t;});
				f_pdfDoc=fn_pdfAppendTable(l_pdfDoc,heading,columnHeaders,pdfTableColumns,columnStyles,pdfData,formatTotals,chartStartY,pdfColumns,rowWinProbsAll,null,rowProjectStatusesAll);	
		}
		
		if(f_pdfDoc){
			window.open(URL.createObjectURL(f_pdfDoc.output("blob")));
		}
		
		}
	}
}
function fn_getNestedValue(object, string) {

	string = string.replace(/\[(\w+)\]/g, '.$1');
	string = string.replace(/^\./, '');
	let a = string.split('.');
	for (let i = 0, n = a.length; i < n; ++i) {
	let k = a[i];
	if (k in object) {
		object = object[k];
		} else {
			return;
			}
		}
		return object;
	}
	
/** Compact PDF column widths; size for header tokens so words like Opportunity# do not mid-wrap. */
function fn_pdfCellWidth(col){
		const DEFAULT_W = 70;
		const MAX_W = 120;
		const ABS_MAX_W = 150;
		const CHAR_W = 5.5; // ~9pt header glyph width
		const PAD = 10;
		var w = DEFAULT_W;
		if(col && col.reportWidth) w = Math.min(parseInt(col.reportWidth, 10) || DEFAULT_W, MAX_W);
		if(col && col.title){
			var maxToken = String(col.title).split(/\s+/).reduce(function(m, t){ return Math.max(m, t.length); }, 0);
			var minForHeader = Math.ceil(maxToken * CHAR_W + PAD);
			w = Math.max(w, Math.min(minForHeader, ABS_MAX_W));
		}
		return w;
}

function fn_createPdf(pdfDoc,title,format,reportWidth){
	
		var today=(new Date()).toLocaleDateString()+' '+(new Date()).toLocaleTimeString()
		var lWidth=1.09*reportWidth
		pdfDoc = new JsPDF({orientation: 'l',  unit: 'pt', format:[lWidth, 841.89]});  // landscape
		pdfDoc.setTextColor(30,144,255);
		
		if(title){
			pdfDoc.setFont('helvetica', 'bold');
			pdfDoc.setFontSize(16);
			pdfDoc.text(title,(reportWidth-title.length)/2,40);
		}
		pdfDoc.setFont('helvetica', 'normal');
		pdfDoc.setFontSize(10);
		pdfDoc.text(`Date:${today}`,reportWidth-100,40);

		fn_tryAddTenantLogo(pdfDoc);

		// Horizontal rule under the report title
		var pageWidth = (pdfDoc.internal && pdfDoc.internal.pageSize && pdfDoc.internal.pageSize.getWidth)
			? pdfDoc.internal.pageSize.getWidth()
			: lWidth;
		pdfDoc.setDrawColor(173, 181, 189);
		pdfDoc.setLineWidth(0.75);
		pdfDoc.line(20, 48, pageWidth - 20, 48);
	
		return pdfDoc;
		
}
function fn_breakLabel(value, column) {
		var label;
		if (!value && value !== 0) label = 'None';
		else if (typeof column.valFmtFn === 'function') label = column.valFmtFn(value);
		else label = value;
		if (label && typeof label === 'object') label = label.name || label.title || 'None';
		if (label == null) label = 'None';
		return String(label);
	}

function fn_slicePalette() {
		return ['#1e90ff','#4169e1','#2e8b57','#e07a3d','#c23b6e','#6b5b95','#3aa6a0','#d4a017','#5c7cfa','#e8590c','#0ca678','#ae3ec9','#1971c2','#74b816','#f03e3e'];
	}

function fn_chartSlices(reportData, reportBreak, allColumns) {
		var column = allColumns.filter(function(c){ return c.field == reportBreak; })[0];
		if (!column) return [];
		var colors = fn_slicePalette();
		var breakValues = [];
		reportData.forEach(function(rec){
			if (breakValues.indexOf(rec[reportBreak]) < 0) breakValues.push(rec[reportBreak]);
		});
		return breakValues.map(function(b){
			return {
				value: b,
				label: fn_breakLabel(b, column),
				count: reportData.filter(function(r){ return r[reportBreak] == b; }).length
			};
		}).filter(function(s){ return s.count > 0; })
		.sort(function(a, b){ return b.count - a.count; })
		.map(function(s, i){
			s.color = colors[i % colors.length];
			return s;
		});
	}

function fn_hexRgb(hex) {
		var h = String(hex).replace('#','');
		return [parseInt(h.substring(0,2),16), parseInt(h.substring(2,4),16), parseInt(h.substring(4,6),16)];
	}

function fn_breakSliceColor(pdfDoc, breakValue) {
		var slices = pdfDoc.breakColorList || [];
		for (var i = 0; i < slices.length; i++) {
			if (slices[i].value == breakValue) return slices[i].color;
		}
		return null;
	}

function fn_tryAddTenantLogo(pdfDoc){
		try {
			var domLogo = typeof document !== 'undefined' ? document.getElementById('tenantLogo') : null;
			if(domLogo && domLogo.complete && domLogo.naturalWidth > 0){
				pdfDoc.addImage(domLogo,15,15,30,30);
				return;
			}
			var logoURL = tenantSettings.general && tenantSettings.general.tenantLogoURL;
			if(!logoURL) return;
			var tenantLogoImg = new Image();
			tenantLogoImg.src = api_baseURL + logoURL;
			if(tenantLogoImg.complete && tenantLogoImg.naturalWidth > 0){
				pdfDoc.addImage(tenantLogoImg,15,15,30,30);
			}
		} catch(e) {
			console.warn('PDF export: skipping tenant logo', e);
		}
}

function fn_winProbabilityTextColor(winProbability) {
	var p = Number(winProbability);
	if (p === 100) return [39, 174, 96];   // green
	if (p === 80) return [155, 89, 182];    // purple
	if (p === 60) return [245, 166, 35];    // orange
	return null; // 0–40% and unknown: default
}

function fn_projectStatusColorItems() {
	return [
		{label: "Canceled", color: [192, 57, 43]},   // red
		{label: "Precon", color: [211, 84, 0]},    // orange
		{label: "Construction Phase", color: [41, 128, 185]},   // blue
		{label: "Project Completed", color: [39, 174, 96]},   // green
	];
}

/** Status name on a project row: name field, nested object, or projectStatusId lookup. */
function fn_rowProjectStatus(row) {
	if (!row) return "";
	var raw = row.projectStatusName || row.projectStatus || row.statusName;
	if (raw && typeof raw === "object") raw = raw.name || raw.statusName || raw.title || "";
	if (raw != null && String(raw).trim() !== "") return String(raw).trim();
	var id = row.projectStatusId;
	if (id && typeof id === "object") {
		raw = id.name || id.statusName || "";
		if (raw) return String(raw).trim();
		id = id.id;
	}
	var list = (refData && refData.projectStatuses) || [];
	for (var i = 0; i < list.length; i++) {
		if (list[i] && list[i].id == id) return list[i].name || "";
	}
	return "";
}

function fn_projectStatusTextColor(status) {
	var name = String(status || "").trim().toLowerCase();
	if (name === "canceled") name = "cancelled";
	var items = fn_projectStatusColorItems();
	for (var i = 0; i < items.length; i++) {
		if (items[i].label.toLowerCase() === name) return items[i].color;
	}
	return null; // Precon, Archived, and unknown: default
}

function fn_pdfFormatReportDate(dateVal) {
	var d = dateVal ? new Date(dateVal) : new Date();
	if (isNaN(d.getTime())) d = new Date();
	return d.toLocaleDateString();
}

function fn_pdfCurrentUserName() {
	try {
		var ui = userInfo && userInfo.getUserInfo ? userInfo.getUserInfo() : null;
		var tm = ui && ui.teamMember;
		return (tm && (tm.teamMemberName || tm.name)) || (ui && (ui.name || ui.email)) || "";
	} catch (e) {
		return "";
	}
}

function fn_pdfDrawReportIntro(pdfDoc, reportTitle, reportCreatedUTC, reportCreatedBy, startY) {
	if (!pdfDoc) return startY || 55;
	var y = startY || 55;
	var name = reportTitle || "Report";
	var createdOn = fn_pdfFormatReportDate(reportCreatedUTC);
	var createdBy = reportCreatedBy || fn_pdfCurrentUserName() || "Unknown";
	var text = "The information shown here pertains to the " + name +
		" created on " + createdOn + " by " + createdBy + ".";
	var pageWidth = (pdfDoc.internal && pdfDoc.internal.pageSize && pdfDoc.internal.pageSize.getWidth)
		? pdfDoc.internal.pageSize.getWidth()
		: 842;
	pdfDoc.setFont("helvetica", "normal");
	pdfDoc.setFontSize(9);
	pdfDoc.setTextColor(73, 80, 87);
	var lines = pdfDoc.splitTextToSize(text, pageWidth - 40);
	pdfDoc.text(lines, 20, y);
	return y + (lines.length * 12) + 10;
}

function fn_pdfDrawWinProbColorKey(pdfDoc, startY) {
	if (!pdfDoc) return startY || 50;
	var y = startY || 52;

	var items = [
		{label: "100% Win Probability", color: [39, 174, 96]},
		{label: "80% Win Probability", color: [155, 89, 182]},
		{label: "60% Win Probability", color: [245, 166, 35]},
		{label: "0–40% Win Probability", color: [33, 37, 41]},
	];

	var x = 20;
	items.forEach(function(item) {
		pdfDoc.setFillColor(item.color[0], item.color[1], item.color[2]);
		pdfDoc.roundedRect(x, y - 8, 10, 10, 2, 2, "F");
		pdfDoc.setFont("helvetica", "normal");
		pdfDoc.setFontSize(8);
		pdfDoc.setTextColor(item.color[0], item.color[1], item.color[2]);
		pdfDoc.text(item.label, x + 14, y);
		x += 150;
	});

	return y + 16;
}

function fn_pdfDrawProjectStatusColorKey(pdfDoc, startY) {
	if (!pdfDoc) return startY || 50;
	var y = startY || 52;
	var items = fn_projectStatusColorItems();

	var x = 20;
	items.forEach(function(item) {
		pdfDoc.setFillColor(item.color[0], item.color[1], item.color[2]);
		pdfDoc.roundedRect(x, y - 8, 10, 10, 2, 2, "F");
		pdfDoc.setFont("helvetica", "normal");
		pdfDoc.setFontSize(8);
		pdfDoc.setTextColor(item.color[0], item.color[1], item.color[2]);
		pdfDoc.text(item.label, x + 14, y);
		x += pdfDoc.getTextWidth(item.label) + 36;
	});

	return y + 16;
}

function fn_pdfFillHeaderBar(doc, x, y, w, h, radius) {
	var r = Math.min(radius || 5, w / 2, h / 2);
	doc.setFillColor(30, 85, 157); // #1e559d
	// Rounded top of the header bar; square off the bottom edge to meet body rows
	doc.roundedRect(x, y, w, h, r, r, "F");
	doc.rect(x, y + h - r, w, r + 0.5, "F");
}
function fn_isReportChartType(chartType) {
		return chartType === "pie" || chartType === "doughnut" || chartType === "bar";
	}

function fn_pdfAppendChart(pdfDoc, reportData, reportBreak, allColumns, chartType, startY) {
		var column = allColumns.filter(function(c){ return c.field == reportBreak; })[0];
		var top = (typeof startY === "number" ? startY : 62);
		if (!column) return top;
		var slices = fn_chartSlices(reportData, reportBreak, allColumns);
		if (!slices.length) return top;
		//if (chartType !== 'bar' && chartType !== 'doughnut') chartType = 'pie';
		var chart = chartType === 'bar' ? fn_barChartImage(slices) : fn_pieChartImage(slices, chartType === 'doughnut');
		var pageSize = pdfDoc.internal.pageSize;
		var pageWidth = pageSize.getWidth ? pageSize.getWidth() : pageSize.width;
		var pageHeight = pageSize.getHeight ? pageSize.getHeight() : pageSize.height;
		var drawW = chart.width;
		var drawH = chart.height;
		var maxW = pageWidth - 40;
		var maxH = Math.max(120, (pageHeight || 842) - top - 80);
		if (drawW > maxW) {
			drawH = drawH * (maxW / drawW);
			drawW = maxW;
		}
		if (drawH > maxH) {
			drawW = drawW * (maxH / drawH);
			drawH = maxH;
		}
		pdfDoc.setFont("helvetica", "bold");
		pdfDoc.setFontSize(11);
		pdfDoc.setTextColor(65, 105, 225);
		pdfDoc.text(column.title + " summary", 20, top);
		pdfDoc.addImage(chart.dataUrl, "PNG", 20, top + 8, drawW, drawH);
		var endY = top + 8 + drawH + 14;
		pdfDoc.chartEndY = endY;
		pdfDoc.breakColorList = slices;
		return endY;
	}
function fn_pdfAppendTable(pdfDoc,heading,columnHeaders,tableColumns,columnStyles,data,totals,startOffset,pdfColumns,rowWinProbs,headingColor,rowProjectStatuses){ 
	
		var startY=(pdfDoc.lastAutoTable && pdfDoc.lastAutoTable.finalY)||startOffset||50;
		var headingY=startY+20;
		var tableY=startY+30;
		pdfDoc.setTextColor(65,105,225);
		var opportunityNoIdx = -1;
		var opportunityNameIdx = -1;
		var projectNoIdx = -1;
		var projectNameIdx = -1;
		if (pdfColumns && pdfColumns.length) {
			opportunityNoIdx = pdfColumns.findIndex(function(c){ return c && c.field === 'opportunityNo'; });
			opportunityNameIdx = pdfColumns.findIndex(function(c){ return c && c.field === 'opportunityName'; });
			projectNoIdx = pdfColumns.findIndex(function(c){ return c && c.field === 'projectNo'; });
			projectNameIdx = pdfColumns.findIndex(function(c){ return c && c.field === 'projectName'; });
		}
		var colLineColor = [206, 212, 218]; // light grey vertical dividers
		var headerBarDrawn = false;
		
		
		if(heading){
			var headingText=String(heading);
			pdfDoc.setFont('helvetica', 'bold');
			pdfDoc.setFontSize(12);
			if(headingColor) {
				var colonAt=headingText.indexOf(':');
				var labelText=colonAt>=0 ? headingText.substring(0, colonAt+1) : '';
				var valueText=colonAt>=0 ? headingText.substring(colonAt+1) : headingText;
				//pdfDoc.setTextColor(65,105,225);
				if(labelText) pdfDoc.text(labelText,20,headingY);
				var labelW=labelText ? pdfDoc.getTextWidth(labelText) : 0;
				var valueX=20+labelW+(labelText?4:0);
				var rgb=fn_hexRgb(headingColor);
				var valueW=pdfDoc.getTextWidth(valueText);
				var barY=headingY-11;
				pdfDoc.setFillColor(rgb[0], rgb[1], rgb[2]);
				pdfDoc.rect(valueX-4, barY, valueW+10, 15, 'F');
				var luminance=(rgb[0]*299 + rgb[1]*587 + rgb[2]*114) / 1000;
				if(luminance < 160) pdfDoc.setTextColor(255,255,255);
				else pdfDoc.setTextColor(20,20,20);
				pdfDoc.text(valueText,valueX,headingY);
			} else {
				pdfDoc.setTextColor(65,105,225);
				pdfDoc.text(headingText,20,headingY);
			}
			pdfDoc.setTextColor(33,37,41);
			pdfDoc.setFont('helvetica', 'normal');
			pdfDoc.setFontSize(9);
		}
		pdfDoc.autoTable({
				head: [columnHeaders],
				body: data,
				foot:totals.length?[totals]:[],
				footStyles:{textColor:[0,0,0],fillColor:[255, 255, 255], lineWidth: 0, fontStyle: 'bold'},
				startY: tableY,
				theme: 'plain',
				styles: {
						overflow: 'linebreak',
						cellWidth: 'wrap',
						minCellHeight: 9,
						halign: "left",
						valign: "top",
						fontSize: 9,
						lineWidth: 0,
						fillColor: [255, 255, 255],
						},
				headStyles: {
						fillColor: [30, 85, 157], // #1e559d
						textColor: [255, 255, 255],
						fontStyle: 'bold',
						halign: 'left',
						valign: 'middle',
						lineWidth: 0,
						minCellHeight: 16,
						},
				alternateRowStyles: {
						fillColor: [242, 242, 242], // light grey zebra striping
						},
				columnStyles,
				tablewidth:'wrap',
				pageBreak:'auto',
				showHead: 'firstPage',
				showFoot: 'lastPage',
				columns:tableColumns,
				willDrawCell: function(hookData) {
					if (hookData.section !== 'head') return;
					var cell = hookData.cell;
					if (!headerBarDrawn && hookData.column.index === 0) {
						var totalW = 0;
						(hookData.table.columns || []).forEach(function(col) {
							totalW += col.width || 0;
						});
						if (totalW > 0) {
							fn_pdfFillHeaderBar(hookData.doc, cell.x, cell.y, totalW, cell.height, 6);
							headerBarDrawn = true;
						}
					}
					// Prevent default square fill from covering the rounded top
					cell.styles.fillColor = false;
				},
				didDrawCell: function(hookData) {
					// Draw vertical divider on the LEFT of each column (except first)
					// so the next cell's fill does not cover the line.
					if (hookData.column.index === 0) return;
					var cell = hookData.cell;
					var doc = hookData.doc;
					doc.setDrawColor(colLineColor[0], colLineColor[1], colLineColor[2]);
					doc.setLineWidth(0.5);
					doc.line(cell.x, cell.y, cell.x, cell.y + cell.height);
				},
				didParseCell: function(hookData) {
					if (hookData.section !== 'body') return;
					var colIdx = hookData.column.index;
					var color = null;
					if (colIdx === opportunityNoIdx || colIdx === opportunityNameIdx) {
						color = fn_winProbabilityTextColor((rowWinProbs || [])[hookData.row.index]);
					} else if (colIdx === projectNoIdx || colIdx === projectNameIdx) {
						color = fn_projectStatusTextColor((rowProjectStatuses || [])[hookData.row.index]);
					}
					if (color) {
						hookData.cell.styles.textColor = color;
						hookData.cell.styles.fontStyle = 'bold';
					}
				},
				});
	return pdfDoc;
	}



function fn_clipCanvasLabel(ctx, text, maxWidth) {
		var label = text == null ? "" : String(text);
		if (!(maxWidth > 0)) return "";
		if (ctx.measureText(label).width <= maxWidth) return label;
		var ellipsis = "...";
		while (label.length > 1 && ctx.measureText(label + ellipsis).width > maxWidth) {
			label = label.slice(0, -1);
		}
		return label + ellipsis;
	}

function fn_pieChartImage(slices, doughnut) {
		var colors = fn_slicePalette();
		// Same on-page size and type as reportCharts wheel cards:
		// donut 90pt, legend 7pt Helvetica, 12pt rows, 8pt swatch, 65% cutout.
		var pie = 90;
		var rowH = 12;
		var swatch = 8;
		var legendColW = 168;
		var legendGap = 12;
		var margin = 8;
		var cols = slices.length > 24 ? 3 : slices.length > 10 ? 2 : 1;
		var rows = Math.ceil(slices.length / cols);
		var width = margin + pie + legendGap + cols * legendColW;
		var height = Math.max(pie + margin, rows * rowH + margin);
		var canvas = document.createElement('canvas');
		var scale = 2;
		canvas.width = width * scale;
		canvas.height = height * scale;
		var ctx = canvas.getContext('2d');
		ctx.scale(scale, scale);
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, width, height);

		var total = 0;
		slices.forEach(function(s){ total += s.count; });
		var cx = margin + pie / 2;
		var cy = height / 2;
		var radius = pie / 2 - 3;
		var angle = -Math.PI / 2;

		if (slices.length === 1) {
			ctx.beginPath();
			ctx.fillStyle = slices[0].color || colors[0];
			ctx.arc(cx, cy, radius, 0, Math.PI * 2);
			ctx.fill();
		} else {
			slices.forEach(function(slice, i){
				var sweep = total ? (slice.count / total) * Math.PI * 2 : 0;
				ctx.beginPath();
				ctx.moveTo(cx, cy);
				ctx.arc(cx, cy, radius, angle, angle + sweep);
				ctx.closePath();
				ctx.fillStyle = slice.color || colors[i % colors.length];
				ctx.fill();
				ctx.strokeStyle = '#ffffff';
				ctx.lineWidth = 2;
				ctx.stroke();
				angle += sweep;
			});
		}

		if (doughnut) {
			ctx.beginPath();
			ctx.fillStyle = '#ffffff';
			ctx.arc(cx, cy, radius * 0.65, 0, Math.PI * 2);
			ctx.fill();
		}

		ctx.font = '7px Helvetica, Arial, sans-serif';
		ctx.textBaseline = 'top';
		slices.forEach(function(slice, i){
			var col = Math.floor(i / rows);
			var row = i % rows;
			var x = margin + pie + legendGap + col * legendColW;
			var y = 4 + row * rowH;
			ctx.fillStyle = slice.color || colors[i % colors.length];
			ctx.fillRect(x, y, swatch, swatch);
			ctx.fillStyle = '#495057';
			var pct = total ? Math.round(slice.count * 100 / total) : 0;
			var suffix = '  ' + slice.count + ' (' + pct + '%)';
			var labelMax = legendColW - swatch - 6 - ctx.measureText(suffix).width;
			var text = fn_clipCanvasLabel(ctx, slice.label, labelMax);
			ctx.fillText(text + suffix, x + swatch + 4, y);
		});

		return {dataUrl: canvas.toDataURL('image/png'), width: width, height: height};
	}

function fn_barChartImage(slices) {
		var colors = fn_slicePalette();
		// Same type size and row pitch as the reportCharts wheel legend.
		var rowH = 12;
		var barH = 8;
		var labelW = 130;
		var barMax = 180;
		var marginX = 8;
		var marginY = 6;
		var valueW = 64;
		var width = marginX + labelW + 8 + barMax + 6 + valueW;
		var height = marginY + slices.length * rowH + 4;
		var canvas = document.createElement('canvas');
		var scale = 2;
		canvas.width = width * scale;
		canvas.height = height * scale;
		var ctx = canvas.getContext('2d');
		ctx.scale(scale, scale);
		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, width, height);
		var max = 0;
		var total = 0;
		slices.forEach(function(s){
			total += s.count;
			if (s.count > max) max = s.count;
		});
		ctx.font = '7px Helvetica, Arial, sans-serif';
		ctx.textBaseline = 'middle';
		slices.forEach(function(slice, i){
			var y = marginY + i * rowH;
			var mid = y + rowH / 2;
			ctx.fillStyle = '#495057';
			ctx.textAlign = 'right';
			ctx.fillText(fn_clipCanvasLabel(ctx, slice.label, labelW - 4), marginX + labelW, mid);
			var barW = max ? (slice.count / max) * barMax : 0;
			if (slice.count > 0 && barW < 2) barW = 2;
			var barX = marginX + labelW + 8;
			ctx.fillStyle = slice.color || colors[i % colors.length];
			ctx.fillRect(barX, y + (rowH - barH) / 2, barW, barH);
			var pct = total ? Math.round(slice.count * 100 / total) : 0;
			ctx.fillStyle = '#495057';
			ctx.textAlign = 'left';
			ctx.fillText(slice.count + ' (' + pct + '%)', barX + barW + 6, mid);
		});
		ctx.textAlign = 'left';
		return {dataUrl: canvas.toDataURL('image/png'), width: width, height: height};
	}	
export{fn_generateReport, fn_pdfCellWidth};
